@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../settings-page.module.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.delivery-options-row {
  display: flex;
  align-items: flex-start;

  border: @settings-page--table--border;
  border-top: none;
  background: @settings-page--table--body--cell--background-color;
  color: @settings-page--table--body--cell--text-color;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;

  &.title {
    background: @settings-page--table--header--cell--background-color;
    color: @settings-page--table--header--cell--text-color;
    border-top: @settings-page--table--border;
    padding: @settings-page--table--cell--padding;
    font-weight: @settings-page--table--header--cell--font-weight;
    > .actions {
      display: flex;
      justify-content: flex-end;
    }
  }
  &.content {
    padding: @space-4 @space-16;
  }

  > .action-button {
    display: flex;
    justify-content: flex-end;
    padding-top: 0;
  }

  > *:not(:last-child) {
    border-right: 1px solid transparent;
  }
  > div {
    padding-top: @space-4;
  }
}

.name {
  display: flex;
  align-items: center;

  width: 250px;
  word-wrap: break-word;
}

.services {
  flex-grow: 1;
}

.pricing {
  width: 85px;
}

.active-column {
  width: 50px;
  min-width: 50px;
  display: flex;
  justify-content: space-around;
  height: 30px;
  > svg {
    color: @settings-page--stores-selected-checkout-row--icon-color;
  }
}

.actions {
  padding-left: 16px;
}

.active-check {
  fill: @settings-page--stores-selected-checkout-row--icon-color;
  height: 30px;
  width: 30px;
  margin-top: -5px;
  padding: 0 5px 5px;
}

.menu-toggle {
  height: 32px;
  width: 32px;
  border-radius: 6px;
  color: @settings-page--stores-selected-checkout-menu--text-color;

  &:hover,
  &:focus {
    background-color: @settings-page--stores-selected-checkout-menu--hover--background-color;
    color: @settings-page--stores-selected-checkout-menu--hover--text-color;
  }

  &:active {
    background-color: @settings-page--stores-selected-checkout-menu--active--background-color;
    color: @settings-page--stores-selected-checkout-menu--active--text-color;
  }
}

.danger {
  color: @settings-page--stores-selected-checkout--danger--text-color;
}

.open-menu-toggle {
  background-color: @settings-page--stores-selected-checkout-open-menu--background-color;
  color: @settings-page--stores-selected-checkout-open-menu--text-color;
}

.menu-toggle-contents {
  display: flex;
  justify-content: center;

  > svg {
    width: 16px;
  }
}
